module.exports = __webpack_public_path__ + "static/img/task-popup-bg.8d1809e4.png";